/**
 * The valid-to date CX-0135 gives a company certificate that never expires.
 *
 * Section 3.2.6 of the standard reserves 31.12.9999 for "no expiration date" instead of leaving the
 * attribute out, and the API stores and returns that date as-is. It is a marker rather than a date
 * to put in front of someone, so every place that renders an expiry has to recognise it.
 */
export const NO_EXPIRY_DATE = '9999-12-31';

/**
 * Tells whether a certificate never expires.
 *
 * An absent value counts as well: a certificate a partner sent without an expiry, or a table row
 * that carries no certificate yet, both arrive with no date at all.
 *
 * @param validUntil - The expiry date as returned by the API, formatted `YYYY-MM-DD`.
 * @returns Whether the expiry should be rendered as "no expiration date".
 */
export const hasNoExpiryDate = (validUntil?: string | null): boolean => {
  return !validUntil || validUntil.slice(0, 10) === NO_EXPIRY_DATE;
};
